module.exports = __webpack_public_path__ + "media/question4_au.80c98b3b.mp3";